/**
 * @param roiCalculatorDocument {Document}
 * @param onOutputFailed {() => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorOutputFailedEvent(roiCalculatorDocument, onOutputFailed) {
    roiCalculatorDocument.addEventListener("outputFailed", () => {
        onOutputFailed();
    });
}
